<template>
  <div v-if="loader" class="loader__wrap">
    <svgicon icon="spinner" class="loader"></svgicon>
  </div>
</template>

<script>
export default {
  name: "loader",
  props: {
    loader: Boolean
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/resuables/loader.vue